import * as React from 'react';
import { PageContent } from '@lcifr/components/page-content';
import { Layout } from 'components/Layout';
import { HeroTechnology } from 'components/HeroTechnology';
import { ProductCategoryList } from 'components/ProductCategoryList';
import { usePageContext } from '@lcifr/pages';

export type TechnologyProps = {
  pageData: any;
};

export default function Technology({ pageData }: TechnologyProps) {
  const context = usePageContext();
  const footer = (pageData as any)?.pageDocument?.page?.footer;
  const header = {
    ...(pageData as any)?.i18n?.header,
    ...(context as any)?.pageDocument?.page?.header,
  };
  const socialProfiles = (pageData as any)?.i18n?.socialProfiles;
  const image = (pageData as any)?.pageDocument?.image;
  const imageCutout = (pageData as any)?.pageDocument?.imageCutout;
  const headline = (pageData as any)?.pageDocument?.hero?.headline;
  const subline = (pageData as any)?.pageDocument?.hero?.subline;

  return (
    <Layout header={header} footer={footer} socialProfiles={socialProfiles}>
      <HeroTechnology
        headline={headline || pageData?.pageDocument?.name}
        subline={subline}
        image={imageCutout || image}
        width={pageData?.pageDocument?.section?.width}
        minHeight={pageData?.pageDocument?.section?.minHeight}
        bg={pageData?.pageDocument?.section?.bg}
        bgImage={pageData?.pageDocument?.section?.bgImage}
        spaceT={pageData?.pageDocument?.section?.spaceT || 0}
        spaceB={pageData?.pageDocument?.section?.spaceB || 0}
        stackSpace={0}
        id={pageData?.pageDocument?.section?.htmlId?.current}
        vRhythm={pageData?.pageDocument?.section?.disableVRhythm ? false : true}
      />
      <ProductCategoryList
        productCategories={pageData?.pageDocument?.categories}
        width={pageData?.pageDocument?.section?.width}
        minHeight={pageData?.pageDocument?.section?.minHeight}
        bg={pageData?.pageDocument?.section?.bg}
        bgImage={pageData?.pageDocument?.section?.bgImage}
        spaceT={pageData?.pageDocument?.section?.spaceT || 0}
        spaceB={pageData?.pageDocument?.section?.spaceB || 0}
        stackSpace={0}
        id={pageData?.pageDocument?.section?.htmlId?.current}
        vRhythm={pageData?.pageDocument?.section?.disableVRhythm ? false : true}
      />
      <PageContent>{(content) => <>{content}</>}</PageContent>
    </Layout>
  );
}
